<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.0002 9.58578L22.4144 21L21.0001 22.4142L9.58594 11L11.0002 9.58578Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.58595 21L21.0002 9.5858L22.4144 11L11.0002 22.4142L9.58595 21Z"
        />
    </svg>
</template>
